import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";

const getSearchByDocumentId = (documentId) => {
  const params = {
    documentId,
  };

  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/DocumentMediateSubCommittee/Search",
    params
  );
};

const getSearchCommitteeList = (documentId) => {
  const params = {
    documentId,
  };

  return axiosGet(
    appsettings.ocpbComplaintAPIUrl +
      "api/DocumentMediateSubCommittee/SearchCommitteeList",
    params
  );
};

const getSearchForAdd = (groupId) => {
  const params = {
    groupId,
  };

  return axiosGet(
    appsettings.ocpbComplaintAPIUrl +
      "api/DocumentMediateSubCommittee/SearchForAdd",
    params
  );
};

const getMeetingList = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl +
      "api/DocumentMediateSubCommittee/MeetingList",
    params
  );
};

const getMeetingApproveList = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl +
      "api/DocumentMediateSubCommittee/MeetingApproveList",
    params
  );
};

const getMeetingById = (id) => {
  const params = {
    id,
  };
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl +
      "api/DocumentMediateSubCommittee/GetMeetingById",
    params
  );
};

const updateData = (params, userId, documentId) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/DocumentMediateSubCommittee/Update?documentId=" +
      documentId +
      "&userId=" +
      userId,
    params
  );
};

const updateStatus = (id, committeeStatus, userId) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/DocumentMediateSubCommittee/UpdateCommitteeStatus?id=" +
      id +
      "&committeeStatus=" +
      committeeStatus +
      "&userId=" +
      userId
  );
};

const deleteData = (id, userId) => {
  const params = {
    id,
    userId,
  };

  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/DocumentMediateSubCommittee/Delete",
    params
  );
};

export {
  getSearchByDocumentId,
  getSearchCommitteeList,
  getSearchForAdd,
  getMeetingList,
  getMeetingApproveList,
  getMeetingById,
  updateData,
  updateStatus,
  deleteData,
};
